import React, { useState, useEffect } from "react";
import PhoneChrome from "./PhoneChrome";
import DesktopShell from "./DesktopShell";
import { useIsDesktop } from "../hooks/useIsDesktop";
import { useIsEmbedded } from "../hooks/useIsEmbedded";
import { ThemeContext } from "../context/ThemeContext";
import "../styles/layout.css";

const Layout = ({ location, children }) => {
  const [theme, setTheme] = useState("dark");
  const isDesktop = useIsDesktop();
  const isEmbedded = useIsEmbedded();
  const isHome = (location?.pathname || "/").replace(/\/+$/, "") === "";

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "dark";
    setTheme(savedTheme);
    document.documentElement.setAttribute("data-theme", savedTheme);

    requestAnimationFrame(() => {
      document.documentElement.classList.remove("no-transition");
    });
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <DesktopShell location={location} theme={theme} toggleTheme={toggleTheme}>
      <div className="site-wrapper">
        {/* Three navigations for three shells. On desktop the taskbar is the
            only one. On a phone, home is its own screen and every other route
            is an app with a nav bar. The site header and footer belonged to a
            fourth thing this is no longer. */}
        {/* Embedded, this page is the contents of a window that already has
            a title bar and a close button of its own. */}
        {!isDesktop && !isHome && !isEmbedded && <PhoneChrome location={location} />}
        <main>{children}</main>
        {!isDesktop && !isHome && !isEmbedded && (
          <span className="home-indicator" aria-hidden="true" />
        )}
      </div>
      </DesktopShell>
    </ThemeContext.Provider>
  );
};

export default Layout;
